export const TRANSLATE_KEY = {
  addressNameOrAddress: 'address_name_or_address',
  totalAddress: 'total_address',
  totalAddressGroup: 'total_address_group',
  dailySettlementCount: 'daily_settlement_count',
  lastDailyReport: 'last_daily_report',
  utcNoticeText: 'utc_notice_text',
};
export const TRANSLATE_PREFIX = 'homePage';
